
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-dark-900/95 backdrop-blur-md shadow-lg shadow-black/20' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png" 
              alt="Logo" 
              className="h-10 sm:h-12 w-auto"
            />
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <button onClick={() => scrollToSection('servicos')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-300 hover:text-red-500">
              Serviços
            </button>
            <button onClick={() => scrollToSection('experiencia')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-300 hover:text-red-500">
              Experiência
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-300 hover:text-red-500">
              Portfólio
            </button>
            <button onClick={() => scrollToSection('depoimentos')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-300 hover:text-red-500">
              Depoimentos
            </button>
            <button onClick={() => scrollToSection('contato')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-300 hover:text-red-500">
              Contato
            </button>
          </div>

          <div className="flex items-center gap-3">
            <a 
              href="https://wa.me/5541992584018" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-4 sm:px-6 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center space-x-2 shadow-lg shadow-red-900/30"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span className="hidden sm:inline">WhatsApp</span>
            </a>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-dark-600 pt-4">
            <div className="flex flex-col space-y-3">
              <button onClick={() => scrollToSection('servicos')} className="text-left text-sm font-medium text-gray-300 hover:text-red-500 py-2 cursor-pointer">
                Serviços
              </button>
              <button onClick={() => scrollToSection('experiencia')} className="text-left text-sm font-medium text-gray-300 hover:text-red-500 py-2 cursor-pointer">
                Experiência
              </button>
              <button onClick={() => scrollToSection('portfolio')} className="text-left text-sm font-medium text-gray-300 hover:text-red-500 py-2 cursor-pointer">
                Portfólio
              </button>
              <button onClick={() => scrollToSection('depoimentos')} className="text-left text-sm font-medium text-gray-300 hover:text-red-500 py-2 cursor-pointer">
                Depoimentos
              </button>
              <button onClick={() => scrollToSection('contato')} className="text-left text-sm font-medium text-gray-300 hover:text-red-500 py-2 cursor-pointer">
                Contato
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
